import { html, nothing } from "lit-html"

const Location = ({ location, link, remote }) => html`
  <p>
    ${location
      ? html`
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=${window.encodeURIComponent(
              location.display
            )}"
            class="block"
          >
            <i class="fas fa-map-marker-alt"></i>
            &nbsp;
            <span>${location.display}</span> (Directions)
          </a>
        `
      : nothing}
    ${link
      ? html`
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="${link}"
            class="block"
          >
            <i class="fas fa-link"></i>
            <span class="ml-3"> ${remote ? "Remote " : ""} Event Link </span>
          </a>
        `
      : nothing}
    ${!location && !link ? html`<span>Location unavailable</span>` : nothing}
  </p>
`
export default Location
